import { render, staticRenderFns } from "./ForumAnswerSection.vue?vue&type=template&id=fe5b5516"
import script from "./ForumAnswerSection.vue?vue&type=script&lang=ts"
export * from "./ForumAnswerSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports